import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { SelectorComponent , SelectorComponent as SelectorComponent_1 } from "~app/common/components/selector/selector.component";
import { GridBaseComponent } from "../grid-base/grid-base.component";

import { FormsModule } from "@angular/forms";

@Component({
    selector: "rask-grid-selector-editor",
    templateUrl: "./grid-selector-editor.component.html",
    styleUrls: ["./grid-selector-editor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent_1,
        FormsModule
    ]
})
export class GridSelectorEditorComponent extends GridBaseComponent implements AfterViewInit {
    @ViewChild(SelectorComponent) comp: SelectorComponent;
    getValue(): any {
        return this.value;
    }

    isPopup(): boolean {
        return true;
    }

    onChange($event) {
        if($event) {
            this.api.stopEditing();
        }
    }

    ngAfterViewInit() {
        this.comp.inputValue = this.value;
        setTimeout(() => {
            this.comp.input.nativeElement.focus();
        }, 10);

        this.comp.focus.pipe(
            takeUntil(this.destroy$)
        ).subscribe(x => {
            if (!x) {
                this.api.stopEditing();
            }
        });
    }

}
